// extracted by mini-css-extract-plugin
var _1 = "card__hZSxG";
var _2 = "wrapper__CLSa5";
export { _1 as "card", _2 as "wrapper" }
